import {
  Badge,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { NavLink } from "react-router-dom";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import { Maybe, User, useUnderApprovalCountSubscription } from "api";
import React from "react";

type UnderApprovalButtonProps = {
  user: Maybe<User>;
};

const UnderApprovalButton: React.FC<UnderApprovalButtonProps> = ({ user }) => {
  const { data } = useUnderApprovalCountSubscription({
    variables: {
      userId: user?.id as string,
    },
    skip: !user?.id,
  });
  return (
    <ListItem disableGutters disablePadding>
      <ListItemButton
        disableGutters
        component={NavLink}
        to={`/profile/${user?.username}/under-approval-posts`}
      >
        <ListItemAvatar>
          <Badge badgeContent={data?.underApprovalCount} color="error">
            <PlaylistAddCheckIcon />
          </Badge>
        </ListItemAvatar>
        <ListItemText
          primaryTypographyProps={{ variant: "h2" }}
          primary="Under Approval"
        />
      </ListItemButton>
    </ListItem>
  );
};

export default UnderApprovalButton;
